import React, { useState } from 'react';
import { Field, Form } from 'react-final-form';
import axios from 'axios';
import styled from 'styled-components';
import { Redirect, useParams } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import { apiUrl } from '../api';
import { Button, ErrorMessage, Input, StyledH1 } from '../components/FormComponents';
import LoginImage from '../static/images/loginImage.png';
import { LoginWrapper, StyledImg, StyledForm } from '../components/LoginComponents';

const StyledInnerForm = styled(StyledForm)`
    min-height: 200px;
`;

export const ResetPasswordForm = () => {
    const [redirect, setRedirect] = useState(null);
    const { token } = useParams();
    return (
        <>
            {redirect && <Redirect to={redirect} />}
            <LoginWrapper>
                <StyledH1>Reset hasła</StyledH1>
                <Form
                    onSubmit={(values) => {
                        axios
                            .put(`${apiUrl}/resetPassword`, values, {})
                            .then(() => {
                                NotificationManager.success('Zmieniono hasło');
                                setRedirect('/');
                            })
                            .catch(() => {
                                NotificationManager.error('spróbuj ponownie', 'Błąd ');
                            });
                    }}
                    validate={(values) => {
                        const errors = {};
                        if (!values.email) {
                            errors.email = 'Podaj adres email';
                        }
                        if (!values.password) {
                            errors.email = 'Podaj hasło';
                        }
                        if (!values.password_confirmation) {
                            errors.password_confirmation = 'Powtórz hasło';
                        }
                        if (
                            values.password &&
                            values.password_confirmation &&
                            values.password !== values.password_confirmation
                        ) {
                            errors.password_confirmation = 'Hasła są różne';
                        }
                        return errors;
                    }}
                    initialValues={{
                        token,
                    }}
                    render={({ handleSubmit }) => (
                        <StyledInnerForm onSubmit={handleSubmit}>
                            <Field
                                name="email"
                                type="email"
                                render={({ input, meta }) => (
                                    <>
                                        <Input {...input} placeholder="Login" />
                                        {meta.error && meta.touched && <ErrorMessage>{meta.error}</ErrorMessage>}
                                    </>
                                )}
                            />

                            <Field
                                name="password"
                                type="password"
                                render={({ input, meta }) => (
                                    <>
                                        <Input {...input} placeholder="Hasło" />
                                        {meta.error && meta.touched && <ErrorMessage>{meta.error}</ErrorMessage>}
                                    </>
                                )}
                            />
                            <Field
                                name="password"
                                type="password"
                                render={({ input, meta }) => (
                                    <>
                                        <Input {...input} placeholder="Powtórz hasło" />
                                        {meta.error && meta.touched && <ErrorMessage>{meta.error}</ErrorMessage>}
                                    </>
                                )}
                            />
                            <Button>Zapisz hasło</Button>
                        </StyledInnerForm>
                    )}
                />
                <StyledImg src={LoginImage} alt="" />
            </LoginWrapper>
        </>
    );
};
